module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sale-opportunity"
  }, [_c('ul', [_vm._l((_vm.listData), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('h2', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openDetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("负责人：" + _vm._s(item.manager))]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v("预计金额：" + _vm._s(item.estimateAmount))]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v("预计结束日期：" + _vm._s(item.estimateTime))])]), _vm._v(" "), _c('span', {
      staticClass: "status"
    }, [_vm._v("状态：" + _vm._s(item.saleStage))])])
  }), _vm._v(" "), (!_vm.listData.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无数据")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(_vm.showLoadmore) ? [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n        加载更多\n      ")] : _vm._e(), _vm._v(" "), (!_vm.showLoadmore && _vm.page.total > _vm.page.size) ? [_vm._v("没有更多")] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c935b4ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/customer/sale-opportunity.vue
// module id = 1340
// module chunks = 82